import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-claim-cme-ce-help-modal',
    templateUrl: './claim-cme-ce-help-modal.component.html',
    styleUrls: ['./claim-cme-ce-help-modal.component.css'],
})
export class ClaimCmeCeHelpModalComponent implements OnInit {
    @Input() contextualHelpHTML: string;

    @Output()
    closeModal = new EventEmitter<any>();

    constructor() {}

    ngOnInit() {}

    onClose() {
        this.closeModal.emit();
    }
}
